import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconChevronRight(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M9 6l6 6l-6 6" />
		</Icon>
	);
}
